// extracted by mini-css-extract-plugin
export default {"component":"index-module__component--SMJP+","link--active":"index-module__link--active--yGqYf"};